var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "encryption-field" }, [
    _c(
      "div",
      { staticStyle: { display: "flex", "align-items": "center" } },
      [
        _vm._t(
          "default",
          [
            _c("span", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v(_vm._s(_vm.displayValue)),
            ]),
          ],
          { value: _vm.isEncrypted && !_vm.isDecrypted ? "" : _vm.displayValue }
        ),
        _vm.isEncrypted
          ? _c("sensitive-view-button", {
              attrs: {
                revealed: _vm.isDecrypted,
                disabled: !_vm.canView,
                loading: _vm.loading,
                label: _vm.hint,
              },
              on: { click: _vm.toggleDecrypt },
            })
          : _vm._e(),
      ],
      2
    ),
    _vm.errorMessage
      ? _c(
          "span",
          { staticClass: "encryption-error", attrs: { role: "alert" } },
          [_vm._v(_vm._s(_vm.errorMessage))]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }